export const BAC_ASK_PLAYER_BANKER = 'bac_ask_player_banker';
export const BAC_STATISTICS_CLICK = 'bac_statistics_click';
export const BAC_ROADMAP_ZOOM = 'bac_roadmap_zoom';
